import Googlemap2 from "../common/GoogleMap/Googlemap2";

export const MapAreaBox = ({ id, PropertyData }) => {
  return (
    <>
      <div className="bg-white rounded-2xl border font-medium text-lg text-gray-500 border-gray-200 p-5 md:p-6 mt-6">
        <h2 className="text-xl font-bold text-[#171717] mb-3">Map</h2>

        <Googlemap2 id={id} location={PropertyData} />
      </div>
    </>
  );
};
